import {HttpWrapperOptions, httpService} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {ClientInfoRequestPayload, RegisterClientRequestPayload} from '../../../shared/models/api/skipassRequestPayload';
import {ClientInfoResponsePayload} from '../../../shared/models/api/skipassResponsePayload';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {skipassSlice} from '../../reducers/skipass';
import {AppThunk} from '../index';
import {getHolderProfile} from '../profile';

export const registerSkipassClient =
  (payload: RegisterClientRequestPayload = {}): AppThunk =>
  async (dispatch) => {
    try {
      await httpService.post<void>(
        getApiRoute(apiUrls.registerSkipassClient),
        payload,
        new HttpWrapperOptions().Wait(true).Errors(true).ThrowException(true),
      );
      dispatch(getSkipassClientInfo());
      dispatch(getHolderProfile());
    } catch (err) {
      console.error(err);
    }
  };

export const unregisterSkipassClient = (): AppThunk => async (dispatch) => {
  try {
    await httpService.delete<void>(
      getApiRoute(apiUrls.unregisterSkipassClient),
      new HttpWrapperOptions().Wait(true).Errors(true).ThrowException(true),
    );
    dispatch(getSkipassClientInfo());
    dispatch(getHolderProfile());
  } catch (err) {
    console.error(err);
  }
};

export const getSkipassClientInfo =
  (options: ClientInfoRequestPayload = {dateStart: null, dateEnd: null}): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(skipassSlice.actions.setClientInfoLoading(true));

      const messagesToIgnore = ['Не найдена интеграция с системой "Барс"'];
      const response = await httpService.get<ClientInfoResponsePayload>(
        getApiRoute(apiUrls.getSkipassClientInfo, options),
        new HttpWrapperOptions()
          .Errors(true)
          .IgnoreDisplayError((message) => messagesToIgnore.includes(message))
          .ThrowException(true),
      );

      if (response) {
        dispatch(skipassSlice.actions.setSkipassClientInfo(response));
      }
    } catch (err) {
      console.error(err);
      dispatch(skipassSlice.actions.setSkipassClientInfo(null));
    } finally {
      dispatch(skipassSlice.actions.setClientInfoLoading(false));
    }
  };
